import { createSlice } from '@reduxjs/toolkit';

const initialState = "idle";

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setLoading: (state) => "loading",
    setIdle: (state) => "idle",
    setImageLoading: (state) => "imageLoading",
    setImageUploading: (state) => "imageUploading",
    setSaving: (state) => "saving",
    // ... any other app states
  }
});

export const { setLoading, setIdle, setImageLoading, setImageUploading, setSaving } = appStateSlice.actions;
export default appStateSlice.reducer;
